import { httpClient } from '@/services/http/httpClient'

type WriteTechnicalReviewParams = {
  ideaId: string
  technicalReviewRequestId: string
  response: string
}

export async function writeTechnicalReview({
  ideaId,
  technicalReviewRequestId,
  response,
}: WriteTechnicalReviewParams): Promise<void> {
  await httpClient.put(`/ideas/evaluations/technical-review/${ideaId}`, {
    technicalReviewRequestId,
    response,
    responseDate: new Date().toISOString(),
  })
}
